import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import signinStyle from '../../Styles/ComponentStyles/Signin.module.scss';

// The sentence under the Google button when the API sent the browser back with ?status=invalid (one block, used by both layouts).
const GoogleSignInNoticeBox = ({ text }: { text: string }) => {
    if (!text) return null;
    return (
        <Grid item xs={12}>
            <Box className={signinStyle.apiErrorBox}>
                <Box className={signinStyle.apiErrorIconWrapper}>
                    <ErrorOutlineIcon fontSize="small" />
                </Box>
                <Typography className={signinStyle.apiErrorText} data-testid="google-signin-notice">
                    {text}
                </Typography>
            </Box>
        </Grid>
    );
};

export default GoogleSignInNoticeBox;
